import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { IdentificationSection } from '../components/IdentificationSection';
import { MechanismSection } from '../components/MechanismSection';
import { DifferenceSection } from '../components/DifferenceSection';
import { OutcomesSection } from '../components/OutcomesSection';
import { BonusesSection } from '../components/BonusesSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { SocialProofPopup } from '../components/SocialProofPopup';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-[#FAF7F2] overflow-x-hidden" data-id="element-262">
      <HeroSection data-id="element-263" />
      <IdentificationSection data-id="element-264" />
      <MechanismSection data-id="element-265" />
      <DifferenceSection data-id="element-266" />
      <OutcomesSection data-id="element-267" />
      <BonusesSection data-id="element-268" />
      <FinalCTASection data-id="element-269" />
      <Footer data-id="element-270" />
      <SocialProofPopup data-id="element-271" />
    </div>;
}